export const PAYMENT_TYPE_ANNUAL = 1;
export const PAYMENT_TYPE_BIANNUAL = 2;
export const PAYMENT_TYPE_QUARTERLY = 4;
export const PAYMENT_TYPE_MONTHLY = 12;

export const CALC_API_DEBOUNCE_DURATION = 500;

export const DATA_STORAGE_KEY = 'GRAWE:react:forms:expert-interpreter-insurance:data';

export const DATE_ERROR_MESSAGES = {
  inFuture: 'Eingegebenes Datum muss in der Zukunft liegen!'
};
